<template>
    <div class="titles-wrap">
        <div class="titles-inner-wrap">
            <p v-for="(title, index) in titlesReorderd.slice(0, 2)"
                :key="title"
                :class="['title-text', 'slide-phase-' + slidePhase, index === 0 ? 'fade-in' : 'fade-out']"
            >{{title}}</p>
        </div>
    </div>
</template>

<script>
    import { ref, toRefs, computed } from 'vue'
    export default {
        name: "ScrollDisplay",
        props: {
            titles: { type: Array, default: () => [] },
            clickToScroll: { type: Boolean, default: () => false },
            initialDelay: { type: [Number, String], default: () => 5000 },
            displayDelay: {
                type: [Number, String],
                default: () => 3000,
                validator: (v) => v >= 2000
            }
        },
        setup (props) {
            // set up titles as refs to keep reactivity
            const { titles } = toRefs(props)
            // start at last index 
            let titleIndex = ref(titles.value.length-1)
            // function to decrement the title index properly
            const incTitleIndex = () => {
                if (titleIndex.value < 1) {
                    titleIndex.value = titles.value.length-1
                } else {
                    titleIndex.value --
                }
            }
            // computed function which returns the titles orderd by the titleIndex
            const titlesReorderd = computed(() => {
                return [titles.value[titleIndex.value], titles.value[(titleIndex.value+1)%titles.value.length]]
            })
            // which slide phase we're in
            let slidePhase = ref(0)

            const slide = () => {
                slidePhase.value = 1
                setTimeout(() => {
                    incTitleIndex()
                    slidePhase.value = 0
                }, 995)
            }

            return { slidePhase, slide, titlesReorderd }
        },
        mounted () {
            const that = this;
            setTimeout(function() {
                (function slider () {
                    that.slide()
                    setTimeout(function() { slider() }, parseInt(that.displayDelay))
                })()
            }, parseInt(that.initialDelay))
        }
    }
</script>

<style scoped lang="scss">
    $title-height: 50px;

    .titles-wrap {
        height: $title-height;
        .titles-inner-wrap {
            transform: translateY(-$title-height);
            line-height: $title-height;
            p { margin: 0; }
        }
    }

    .title-text {
        &.fade-in {
            opacity: 0
        }
        &.slide-phase-1 {
            opacity: 0;
        }
    }

    .slide-phase-1 {
        animation: slide-down 1000ms;
        &.fade-in {
            --fade-phase-one: 0;
            --fade-phase-two-a: 0;
            --fade-phase-two: .5;
            --fade-phase-two-b: .75;
            --fade-phase-three: 1;
        }
        &.fade-out {
            --fade-phase-one: 1;
            --fade-phase-two-a: 0;
            --fade-phase-two: 0;
            --fade-phase-two-b: 0;
            --fade-phase-three: 0;
        }
    }

    @keyframes slide-down {
        0% {
            transform: translateY(0px);
            opacity: var(--fade-phase-one);
        }

        25% {
            opacity: var(--fade-phase-two-a);
        }

        50% {
            opacity: var(--fade-phase-two);
        }

        75% {
            opacity: var(--fade-phase-two-b);
        }

        100% {
            transform: translateY($title-height);
            opacity: var(--fade-phase-three);
        }
    }
</style>